import dayjs from 'dayjs';

export function formatCreatedAtDate(inputDate: string) {
  const parsedDate = dayjs(inputDate);
  const formattedDate = parsedDate.format('D MMM, YYYY');

  return formattedDate;
}
